var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavIcon8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_796_2190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1803 13.5004C12.7604 12.1912 11.9357 11.0492 10.8251 10.239C9.7144 9.42877 8.37511 8.99219 7.00031 8.99219C5.6255 8.99219 4.28621 9.42877 3.17552 10.239C2.06484 11.0492 1.24013 12.1912 0.820312 13.5004H13.1803Z",
    stroke: "#F0F0F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99964 9.00024C9.33694 9.00024 11.2317 7.10548 11.2317 4.76818C11.2317 2.43088 9.33694 0.536133 6.99964 0.536133C4.66234 0.536133 2.76758 2.43088 2.76758 4.76818C2.76758 7.10548 4.66234 9.00024 6.99964 9.00024Z",
    stroke: "#F0F0F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38294 6.40576C8.38294 6.40576 8.03179 7.0967 7.00104 7.0967C5.97029 7.0967 5.61914 6.40576 5.61914 6.40576",
    stroke: "#F0F0F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1566 3.96243C11.1471 3.96249 11.1377 3.96252 11.1283 3.96252C9.89815 3.96252 8.79372 3.42433 8.03759 2.57057C7.28147 3.42435 6.17703 3.96255 4.94688 3.96255C4.23254 3.96255 3.56058 3.78106 2.97461 3.46168C3.52515 1.76377 5.11978 0.536133 7.00115 0.536133C9.06292 0.536133 10.7803 2.0105 11.1566 3.96243Z",
    stroke: "#F0F0F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_796_2190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon8);
export default __webpack_public_path__ + "static/media/navIcon-8.0e55efcdfcc4ae79288ed29e8fae5ba1.svg";
export { ForwardRef as ReactComponent };